export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ExternalHtml.vue?vue&type=template&id=0003423e&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/ExternalHtml.vue?vue&type=template&id=0003423e&
// module id = 1762
// module chunks = 0